import store from '../store'
import {
  addAvatar,
  addCharacter,
  addEncounter,
  addEncounterMonster,
  addGroupRoll,
  addInvitation,
  addRegistry,
  addRoll,
  addShortcut,
  addVariable,
  destroyAvatar,
  destroyCharacter,
  destroyEncounter,
  destroyEncounterMonster,
  destroyGroupRoll,
  destroyInvitation,
  destroyRegistry,
  destroyShortcut,
  destroyVariable,
  updateCharacter,
  updateEncounter,
  updateEncounterMonster,
  updateGroupRoll,
  updateRegistry,
  updateShortcut,
  updateVariable,
  updateGame,
  reorderGame,
  reorderInitiativeQueueItems,
  updateInitiativeQueue,
  addGameSetting,
  updateGameSetting,
  destroyGameSetting,
} from '../actions'
import { addGameRole, destroyGameRole, updateGameRole } from '../actions/game_roles'
import { Color } from '@systemic-games/pixels-web-connect'

export function connect() {
  const state = store.getState()
  const isViewer = state.client.isViewer
  const gameId = state.game.id

  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
  const ws = new WebSocket(`${protocol}://${location.host}/cable?is_viewer=${isViewer}`)

  ws.onopen = () => {
    const config = {
      command: 'subscribe',
      identifier: JSON.stringify({
        channel: 'GameChannel',
        game: gameId
      }),
    }
    ws.send(JSON.stringify(config))
  }

  ws.onclose = e => {
    console.log(
      'Socket is closed. Reconnect will be attempted in 1 second.',
      e.reason,
    )
    setTimeout(() => {
      connect()
    }, 1000)
  }

  ws.onmessage = event => {
    const data = JSON.parse(event.data)
    if (data.identifier) {
      const { channel, game } = JSON.parse(data.identifier)
      console.log('🕷🕸', { channel, game, data })

      if (
        channel == 'GameChannel' &&
        game === store.getState().game.id &&
        data.message
      ) {
        const action = `${data.message.action}-${data.message.type}`

        store.dispatch(
          handlers[action](data.message.model)
        )
      }
    }
  }

  const handlers = {
    'create-avatar': addAvatar,
    'create-character': addCharacter,
    'create-custom_initiative_entry': (model) => ({ type: 'CREATE_CUSTOM_INITIATIVE_ENTRY', model }),
    'create-encounter': addEncounter,
    'create-encounter_monster': addEncounterMonster,
    'create-group_roll': addGroupRoll,
    'create-invitation': addInvitation,
    'create-registry': addRegistry,
    'create-roll': addRoll,
    'create-shortcut': addShortcut,
    'create-variable': addVariable,
    'destroy-avatar': destroyAvatar,
    'destroy-character': destroyCharacter,
    'destroy-custom_initiative_entry': (model) => ({ type: 'DESTROY_CUSTOM_INITIATIVE_ENTRY', model }),
    'destroy-encounter': destroyEncounter,
    'destroy-encounter_monster': destroyEncounterMonster,
    'destroy-group_roll': destroyGroupRoll,
    'destroy-invitation': destroyInvitation,
    'destroy-registry': destroyRegistry,
    'destroy-shortcut': destroyShortcut,
    'destroy-variable': destroyVariable,
    'update-character': updateCharacter,
    'update-custom_initiative_entry': (model) => ({ type: 'UPDATE_CUSTOM_INITIATIVE_ENTRY', model }),
    'update-group_roll': updateGroupRoll,
    'update-encounter': updateEncounter,
    'update-encounter_monster': updateEncounterMonster,
    'update-game': updateGame,
    'update-registry': updateRegistry,
    'update-shortcut': updateShortcut,
    'update-variable': updateVariable,
    'reorder-game': reorderGame,
    'reorder-initiative_queue_items': reorderInitiativeQueueItems,
    'update-initiative_queue': updateInitiativeQueue,
    'create-game_setting': addGameSetting,
    'update-game_setting': updateGameSetting,
    'destroy-game_setting': destroyGameSetting,
    'create-game_role': addGameRole,
    'destroy-game_role': destroyGameRole,
    'update-game_role': updateGameRole,
  }
}
